import { render, staticRenderFns } from "./newMap.vue?vue&type=template&id=252e4456&"
import script from "./newMap.vue?vue&type=script&lang=js&"
export * from "./newMap.vue?vue&type=script&lang=js&"
import style0 from "./newMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports